export default __webpack_public_path__ + "static/media/user.2a2c27a3.svg";